export default __webpack_public_path__ + "static/media/hotei05.7906cf19.webp";